export const SETTING_AMDOCS_SCAPE_TASK = 'adm_amdocs_scrape_task'
export const SETTINGS_IP_WHITELIST = 'su_ip_whitelist'